export default {
  hero: {
    title: '成功案例展示',
    subtitle: '探索我们如何帮助全球客户解决复杂业务挑战，实现数字化转型与业务增长',
    imageAlt: '案例展示背景图'
  },
  filter: {
    title: '双维度案例筛选',
    regionTitle: '按区域筛选',
    industryTitle: '按行业筛选',
    currentFilter: '当前筛选',
    clearAll: '清除全部',
    regions: {
      all: '全部区域',
      china: '中国大陆',
      hongkong: '中国香港',
      taiwan: '中国台湾',
      japan: '日本',
      korea: '韩国',
      singapore: '新加坡',
      america: '美洲',
      europe: '欧洲'
    },
    industries: {
      all: '全部行业',
      manufacturing: '制造业',
      finance: '金融',
      healthcare: '医疗健康',
      retail: '零售电商',
      government: '政府公共事业',
      professional: '专业服务'
    }
  },
  caseList: {
    resultCount: '筛选结果',
    projectBackground: '项目背景',
    implementation: '实施内容',
    loadMore: '加载更多案例',
    loading: '加载中...',
    noMore: '没有更多案例了'
  },
  cases: {
    case1: {
      regionLabel: '日本',
      industryLabel: '制造业',
      title: '日本制造企业混合云迁移',
      background: '某日本大型汽车零部件制造商，全球员工12,000人，在中国、泰国、美国设有生产基地。面临跨地域数据同步延迟、系统维护成本高、业务连续性保障不足等问题，需要构建高效、安全的混合云架构。',
      implementation: [
        '跨中日两国的混合云架构设计与实施',
        '核心业务系统向AWS云平台迁移',
        '构建分布式数据同步与容灾备份体系',
        '网络架构重构与全球加速优化',
        '7×24小时全球化运维体系搭建'
      ],
      metrics: [
        { value: '40%', label: '系统响应速度提升' },
        { value: '25%', label: '运维成本降低' },
        { value: '100%', label: '合规通过率' }
      ]
    },
    case2: {
      regionLabel: '新加坡',
      industryLabel: '金融',
      title: '新加坡金融科技公司数据安全升级',
      background: '新加坡领先的支付服务提供商，处理每日交易量超过500万笔，年交易额达150亿新元。面临日益严格的MAS（新加坡金融管理局）监管要求、数据泄露风险、跨境支付安全等挑战，需要构建符合国际标准的多层级数据安全防护体系。',
      implementation: [
        '端到端数据加密系统部署（AES-256标准）',
        '多因素身份认证与权限管理体系',
        '实时威胁检测与安全事件响应平台',
        'MAS合规性审计准备与文档化',
        'DDoS防护与API安全加固',
        '数据备份与灾难恢复方案实施'
      ],
      metrics: [
        { value: '95%', label: '安全事件减少' },
        { value: '100%', label: 'MAS合规审计通过' },
        { value: '60%', label: '威胁响应时间缩短' }
      ]
    },
    case3: {
      regionLabel: '韩国',
      industryLabel: '医疗健康',
      title: '韩国医疗机构AI辅助诊断平台',
      background: '韩国首尔大型综合医院，拥有1,200张病床和年诊疗量超过80万人次。面临影像诊断医师不足、诊断准确率受人为因素影响、患者等待时间长等问题，需要引入AI技术提升诊断效率和准确性。',
      implementation: [
        'AI影像分析系统部署与定制化训练',
        '医学影像数据标注与深度学习模型优化',
        '医院现有PACS系统集成与数据接口开发',
        '医师培训与AI辅助诊断流程设计',
        '诊断质量控制与AI系统持续优化机制建立'
      ],
      metrics: [
        { value: '35%', label: '诊断准确率提升' },
        { value: '70%', label: '影像处理时间减少' },
        { value: '42%', label: '患者满意度提升' }
      ]
    },
    case4: {
      regionLabel: '中国香港',
      industryLabel: '零售电商',
      title: '香港零售集团全渠道会员与库存平台',
      background: '某香港连锁零售品牌同时运营直营网点、线上商城与会员体系，长期面临线上线下库存不一致、订单履约视图分散、会员画像割裂以及营销复购难以量化的问题，需要构建统一的全渠道零售运营平台。',
      implementation: [
        '建设全渠道中台，统一商品、库存、订单和会员主数据',
        '部署客户数据平台，整合门店、商城、活动和会员标签',
        '接入云 POS、移动支付和门店 CRM，提升一线门店执行效率',
        '上线仓配一体化可视化看板，优化补货策略与门店调拨',
        '打通精准营销与个性化推荐流程，提升客户忠诚度运营能力'
      ],
      metrics: [
        { value: '32%', label: '库存准确率提升' },
        { value: '28%', label: '复购率提升' },
        { value: '41%', label: '缺货率下降' }
      ]
    },
    case5: {
      regionLabel: '中国大陆',
      industryLabel: '专业服务',
      title: '华东咨询机构安全知识协作平台',
      background: '某区域性咨询服务集团拥有跨城市项目交付团队，文档版本分散、客户材料权限控制复杂、项目工时回填滞后，且远程协作频繁，需要建设一个兼顾安全协作、项目计费和知识沉淀的一体化工作平台。',
      implementation: [
        '部署具备精细权限和审计追踪能力的安全文档管理平台',
        '集成企业级会议与统一通信工具，支持项目团队远程协作',
        '打通时间跟踪、项目管理与计费系统，提高可计费工时采集率',
        '使用流程自动化能力优化客户入场、合同审查和交付审批',
        '建立知识标签、案例归档和搜索机制，沉淀可复用项目经验'
      ],
      metrics: [
        { value: '68%', label: '文档检索效率提升' },
        { value: '22%', label: '可计费工时采集率提升' },
        { value: '45%', label: '客户入场周期缩短' }
      ]
    }
  },
  consultation: {
    title: '寻找适合您企业的解决方案？',
    description: '无论您身处哪个行业，位于哪个地区，我们都能为您量身定制数字化转型方案。填写表单，获取免费咨询服务！',
    button: '获取免费咨询'
  }
}
